// Copyright (c) 2022 Enabler Interactive Pty Ltd

import React, { Component } from 'react'

export class DynamicSecSidebar extends Component {
    constructor(props) {
        super(props)

        this.populateTopPanelItems = this.populateTopPanelItems.bind(this)
        this.clickPanelItem = this.clickPanelItem.bind(this)
        this.loadIcon = this.loadIcon.bind(this)
    }

    clickPanelItem(e) {
        e.preventDefault()

        this.props.handleClickedPanelItem(e.target.getAttribute("data-key"), e.target.getAttribute("data-index"), e.target.getAttribute("data-providerName"))
    }

    populateTopPanelItems() {
        return this.props.menuItems.map((item, index) => {
            let styleClasses = "panel-item"

            if (this.props.activeIndex === index) {
                styleClasses += " active"
            }

            return (
                <div key={index} className={styleClasses} data-key={item.key} data-index={index} data-providerName={item.title} onClick={this.clickPanelItem}>
                    <div className="icon-container" data-key={item.key} data-index={index} data-providerName={item.title}>
                        {this.loadIcon(item.icon, item.key, index, item.title)}
                    </div>
                    <span data-key={item.key} data-index={index} data-providerName={item.title}>
                        {item.title}
                    </span>
                </div>
            )
        })
    }

    loadIcon(imageSrc, key, index, title) {
        let finalImage = (<img src="#" alt="icon" />)

        if (imageSrc !== "#") {
            finalImage = (
                <img src={imageSrc} alt="icon" data-key={key} data-index={index} loadIcon data-providerName={title} />
            )
        }
        else {
            let initials = title.charAt(0) + title.charAt(1)

            finalImage = (
                <div className="company-initials" data-key={key} data-index={index} data-providerName={title}>
                    {initials}
                </div>
            )
        }
        return finalImage
    }

    render() {
        return (
            <div className="sec-side-bar-container">
                <section className="sec-side-panel">
                    <section className="top">
                        {this.populateTopPanelItems()}
                    </section>

                </section>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/dynamicSecSidebar.js